import { combineSchooInfoLabels } from '../../category-reader/utils';
/**
 * 카테고리 라벨들을 조합하여 퀴즈 제목을 생성합니다.
 * 각 라벨의 앞뒤 공백을 제거하고, 빈 값은 자동으로 제외한 후, 남은 값들을 공백으로 연결합니다.
 *
 * @example
 * generateQuizTitle({
 *   schoolInfoLabel: 'Elementary 1st',
 *   subjectLabel: ' Math', // 앞에 공백이 있어도 자동 제거
 *   publisherLabel: ''
 * }) // => 'Elementary 1st Math'
 */
export const generateQuizTitle = ({
  schoolInfoLabel,
  subjectLabel,
  publisherLabel,
}: {
  schoolInfoLabel: {
    schoolTypeLabel?: string;
    gradeLabel?: string;
    semesterLabel?: string;
  };
  subjectLabel?: string;
  publisherLabel?: string;
}) => {
  const parts = [
    combineSchooInfoLabels(schoolInfoLabel),
    subjectLabel,
    publisherLabel,
  ]
    .map(label => label?.trim()) // 각 라벨의 앞뒤 공백 제거
    .filter(Boolean); // 빈 값 제거
  return parts.join(' ');
};
